import {ShopItem} from './ShopItem';
import {OrderItem} from './OrderItem';
import {ReviewItem} from './ReviewItem';
import {ProfileItem} from './ProfileItem';
import {TrendingItem} from './TrendingItem';
import {WishlistItem} from './WishlistItem';
import {PromocodeItem} from './PromocodeItem';
import {NewArrivalItem} from './NewArrivalItem';

export const items = {
  ShopItem,
  OrderItem,
  ReviewItem,
  ProfileItem,
  WishlistItem,
  TrendingItem,
  PromocodeItem,
  NewArrivalItem,
};
